module.exports = __webpack_public_path__ + "static/media/dg9.0de9e85d.jpg";